import React from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';

export default function RequireAuthHOC(ComposedComponent, ignoreEmployeeLogin) {
  function RequireAuthentication(props) {
    const { location } = props;
    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      const decoded = jwtDecode(jwt);

      // if (!decoded.restaurant && location.pathname !== '/main') {
      //   return (
      //     <Redirect to="/main" />
      //   );
      // }

      //console.log('user role -> ');
      //console.log(decoded.userid);
      //console.log(decoded.role);

      //if (!decoded.userid && !ignoreEmployeeLogin) {
      if (!decoded.userid) {
        return (
          <Redirect to="/main" />
        );
      }

      if (decoded.role === 'agency' && location.pathname !== '/settlement/agency') {
        //console.log('user role -> ');
        return (
          <Redirect to="/settlement/agency" />
        );
      }
      else if (decoded.role === 'client' && location.pathname !== '/settlement/client') {
        //console.log('user role -> ');
        return (
          <Redirect to="/settlement/client" />
        );
      }

      return (
        <ComposedComponent {...props} />
      );
    }

    return (
      <Redirect to="/sign-in" />
    );
  }

  return RequireAuthentication;
}
